import { firestore } from 'firebase';

/* istanbul ignore file */
export class InitialContactDialogData {
  public serviceDocumentKey: string;
  public clientUserKey: string;
  public message: string;
  public timeStamp: firestore.Timestamp;

  constructor(init?: Partial<InitialContactDialogData>) {
    Object.assign(this, init);
  }
}
